const GTM_ID = "GTM-W7SJKHGV";

let gtmInjected = false;

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export type GtmConsentCategories = {
  analytics: boolean;
  marketing: boolean;
};

function pushConsentUpdate(categories: GtmConsentCategories): void {
  window.dataLayer = window.dataLayer || [];

  // GTM's consent API only processes a real `arguments` object pushed to the
  // dataLayer — a plain array is silently ignored.
  function gtag(..._args: unknown[]): void {
    // biome-ignore lint/complexity/noArguments: GTM requires the arguments object
    window.dataLayer?.push(arguments);
  }

  gtag("consent", "update", {
    ad_storage: categories.marketing ? "granted" : "denied",
    ad_user_data: categories.marketing ? "granted" : "denied",
    ad_personalization: categories.marketing ? "granted" : "denied",
    analytics_storage: categories.analytics ? "granted" : "denied",
  });
}

// Injects the GTM container once and keeps Consent Mode in sync with the current
// decision (so a marketing tag stays denied under an analytics-only consent).
// Only ever called after the user has granted a non-essential category.
export function loadGoogleTagManager(categories: GtmConsentCategories): void {
  pushConsentUpdate(categories);

  if (gtmInjected) return;
  gtmInjected = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}

// Reconciles GTM with the current decision on every change: injects (and grants)
// the first time a non-essential category is allowed, and — crucially — pushes a
// `denied` Consent Mode update when a category is withdrawn after the container
// already loaded. A user who never granted anything never loads GTM.
export function syncGoogleTagManagerConsent(
  categories: GtmConsentCategories,
): void {
  if (categories.analytics || categories.marketing) {
    loadGoogleTagManager(categories);
  } else if (gtmInjected) {
    pushConsentUpdate(categories);
  }
}
